import { BaseEntity } from "yt-ng-framework";
import { NgbDate } from "@ng-bootstrap/ng-bootstrap";
export class EPrijemnicaView extends BaseEntity{

    constructor(){
        super();
    }

    BrojPrijemnice: string;
    Datum: NgbDate;    
    Komitent: string; 
    KomitentMesto: string; 
    StatusGenericName: string;
    StatusColor:string;
    StatusTooltip:string;
    OsvezivogStatusa:boolean;
    MasterDokumID: number;
    NoviKomitent: boolean;  
    ProvajderID: number; 
    BrojUlaznePrijemnice: string;
    KomitentPosiljalac: string;
    KomitentPosiljalacMesto: string;
    BrojUlazneOtpremnice: string;

    Deserialize(input: any){
        this.ID = input.ID;
        this.BrojPrijemnice = input.BrojDokumenta;
        this.Datum = input.Datum;
        this.Komitent = input.Komitent;
        this.KomitentMesto = input.KomitentMesto;
        this.StatusGenericName = input.StatusGenericName;
        this.StatusColor=input.StatusColor;
        this.StatusTooltip= input.StatusTooltip;
        this.OsvezivogStatusa = input.OsvezivogStatusa;
        this.MasterDokumID=input.MasterDokumID;
        this.StatusGenericName = input.StatusGenericName;
        this.StatusColor = input.StatusColor;
        this.StatusTooltip = input.StatusTooltip;
        this.ProvajderID = input.ProvajderID;
        this.NoviKomitent = input.NoviKomitent;
        this.BrojUlaznePrijemnice = input.BrojUlaznePrijemnice;
        this.KomitentPosiljalac =  input.KomitentPosiljalac;
        this.KomitentPosiljalacMesto = input.KomitentPosiljalacMesto;
        this.BrojUlazneOtpremnice = input.BrojUlazneOtpremnice;
        return this;
    }

    Serialize(input: EPrijemnicaView){
        return input;
    }
}